import { render, staticRenderFns } from "./PageBottom.vue?vue&type=template&id=80644c38&scoped=true&"
import script from "./PageBottom.vue?vue&type=script&lang=js&"
export * from "./PageBottom.vue?vue&type=script&lang=js&"
import style0 from "./PageBottom.vue?vue&type=style&index=0&id=80644c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80644c38",
  null
  
)

export default component.exports